import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class FICBaseButton extends Component {
  constructor (props) {
    super(props)
    this.clickable = true
  }

  render () {
    const { onClick, isDisabled, isLoading, target, className, href, style, renderButton } = this.props

    return <a
      className={className}
      onClick={() => {
        if (!this.clickable || isLoading || isDisabled) {
          return
        }

        this.clickable = false
        setTimeout(() => {
          this.clickable = true
        }, 500)
        if (onClick) {
          onClick()
        }
      }}
      href={!isDisabled ? href : undefined}
      target={target}
      style={style}
    >
      {renderButton(this.props, this.state)}
    </a>
  }
}

FICBaseButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  renderButton: PropTypes.func
}

FICBaseButton.defaultProps = {
  className: undefined,
  href: undefined,
  target: undefined,
  onClick: undefined,
  style: undefined,
  isDisabled: false,
  isLoading: false,
  renderButton: undefined
}



// WEBPACK FOOTER //
// ./src/common/components-v2/FICButton/FICBaseButton.js